import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Layout, Loader, TextField } from "../../components";
import {
  Avatar,
  Col,
  Divider,
  Modal,
  Pagination,
  Row,
  Switch,
  Table,
  Tabs,
  Typography,
} from "antd";
import Header from "../../components/Layout/Header";
import { GamesActions, PrizePoolAction } from "../../store/actions";
import { IoIosInformationCircleOutline } from "react-icons/io";
import {
  FaCheckDouble,
  FaClock,
  FaEye,
  FaPen,
  FaRegQuestionCircle,
  FaSearch,
} from "react-icons/fa";
import { Images, Utils } from "../../config";
import moment from "moment";
import { Input } from "antd";
import { Actions } from "../../components/atoms/Actions";
import GameDetailsModal from "./molecules/GameDetailsModal";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Stack,
} from "@mui/material";
import { CustomButton } from "../../components/ui/button/CustomButton";
import { set } from "date-fns";
import { render } from "@testing-library/react";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";

const { TabPane } = Tabs;

const PrizePool = () => {
  const history = useHistory();
  const [currentPage, setCurrentPage] = useState(1);
  const dispatch = useDispatch();
  const data = useSelector((store) => {
    return store.PrizePoolReducer;
  });
  console.log(data, "Burhannnnn");
  const winnerCount = data?.winners?.count;

  // const dataPool = useSelector((store) => {
  //   return store.PrizePoolReducer;
  // });
  const [tabName, setTabName] = useState("done");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [isManagerEditModalOpen, setIsManagerEditModalOpen] = useState(false);
  const [requiredUsers, setRequiredUsers] = useState(
    data?.gameDetail?.requiredUsers
  );

  const [requiredUsersPool, setRequiredUsersPool] = useState(
    data?.luckydraw?.data?.requiredUsers
  );

  const [winningAmount, setWinningAmount] = useState(
    data?.luckydraw?.data?.winningAmount
  );

  console.log(requiredUsersPool, winningAmount, "requiredUsersPool");

  const handleCancel = () => {
    setIsModalOpen(false);
    setIsEditModalOpen(false);
    setIsManagerEditModalOpen(false);
  };

  // useEffect(() => {
  //   dispatch(PrizePoolAction.GetPrizePool());
  // }, []);

  useEffect(() => {
    if (tabName === "done") {
      dispatch(PrizePoolAction.GetPrizePool());
    } else if (tabName === "manager") {
      console.log(tabName, "dwdadef");

      dispatch(PrizePoolAction.GetLuckydrawConfig());
    } else if (tabName === "list") {
      const getUsers = {
        limit: 10,
        offSet: 0,
      };
      dispatch(PrizePoolAction.GetLuckydrawPools(getUsers));
    } else if (tabName === "winner") {
      const getUsers = {
        limit: 10,
        offSet: 0,
      };
      dispatch(PrizePoolAction.GetLuckydrawWinners(getUsers));
    }
  }, [tabName]);

  useEffect(() => {
    if (data?.luckydraw?.data) {
      setRequiredUsersPool(data.luckydraw.data.requiredUsers);
      setWinningAmount(data.luckydraw.data.winningAmount);
    }
  }, [data]);

  const UpdatePrizeDetails = () => {
    if (requiredUsers % 100 === 0) {
      const dataUpdate = {
        id: data?.gameDetail?.id,
        requiredUsers: requiredUsers
          ? requiredUsers
          : data?.gameDetail?.requiredUsers,
      };
      dispatch(
        PrizePoolAction.UpdatePrizePool_Detail(dataUpdate, () => {
          dispatch(PrizePoolAction.GetPrizePool());
          Utils.showSnackBar({
            message: "Prize Pool Updated Successfully",
            severity: "success",
          });
          setIsEditModalOpen(false);
        })
      );
    } else {
      Utils.showSnackBar({
        message: "Please enter in multiples of 100",
        severity: "error",
      });
    }
  };

  const UpdateManagerPoolDetails = () => {
    const payload = {
      id: data?.luckydraw?.data?.id,
      requiredUsers: requiredUsersPool,
      winningAmount: winningAmount,
    };
    dispatch(
      PrizePoolAction.UpdateLuckydrawConfig_Detail(payload, () => {
        dispatch(PrizePoolAction.GetLuckydrawConfig());
        Utils.showSnackBar({
          message: "Prize Pool Updated Successfully",
          severity: "success",
        });
        setIsManagerEditModalOpen(false);
      })
    );
  };

  const headerProps = {
    mainHeading: "Prize Pool Management",
    subHeading: ``,
  };

  const handle_payDone = (p) => {
    const limit = 10;
    let offSet = (p - 1) * limit;
    setCurrentPage(p);
    const getUsersByPage = {
      limit,
      offSet,
    };
    dispatch(PrizePoolAction.GetLuckydrawWinners(getUsersByPage));
  };

  const handle_pool = (p) => {
    const limit = 10;
    let offSet = (p - 1) * limit;
    setCurrentPage(p);
    const getUsersByPage = {
      limit,
      offSet,
    };
    dispatch(PrizePoolAction.GetLuckydrawPools(getUsersByPage));
  };

  const columns = [
    {
      title: "",
      dataIndex: "imageThumbUrl",
      key: "imageThumbUrl",
      width: "1%",
      render: (i, b) => <Avatar src={i} />,
    },
    {
      title: "Game Name",
      dataIndex: "name",
      key: "name",
      width: "2%",
    },
    {
      title: "Required Users in Pool",
      dataIndex: "requiredUsers",
      key: "requiredUsers",
      width: "5%",
    },
    {
      title: "Current User in Pool",
      dataIndex: "usersInCurrentPool",
      key: "usersInCurrentPool",
      width: "5%",
    },
    {
      title: "Action",
      dataIndex: "id",
      key: "id",
      width: "5%",
      render: (a, b) => (
        <Row>
          <Col span={6}>
            <Actions.Button
              title={"Edit PrizePool Config"}
              icon={FaPen}
              sx={{
                bgcolor: "#eef7eb",
                color: "#54ac3f",
                // marginRight: "10px"
              }}
              onClick={() => {
                dispatch(
                  PrizePoolAction.GetPrizePool_Detail(a, () =>
                    setIsEditModalOpen(true)
                  )
                );
              }}
            />
          </Col>
          <Col span={6}>
            <Actions.Button
              title={"View PrizePool Details"}
              icon={FaEye}
              sx={{
                bgcolor: "#d9dcea",
              }}
              onClick={() => {
                dispatch(
                  PrizePoolAction.GetPrizePool_Detail(a, setIsModalOpen(true))
                );
              }}
            />
          </Col>
        </Row>
      ),
    },
  ];

  const columnsManager = [
    // {
    //   title: "Raffle Name",
    //   dataIndex: "name",
    //   key: "name",
    //   // width: "2%",
    // },
    {
      title: "Required Users in Pool",
      dataIndex: "requiredUsers",
      key: "requiredUsers",
      // width: "5%",
    },
    {
      title: "Current User in Pool",
      dataIndex: "usersInCurrentPool",
      key: "usersInCurrentPool",
      // width: "5%",
    },
    {
      title: "Winner Coins",
      dataIndex: "winningAmount",
      key: "winningAmount",
      // width: "5%",
    },
    {
      title: "Action",
      dataIndex: "id",
      key: "id",
      // width: "5%",
      render: (a, b) => (
        <Actions.Button
          title={"Edit PrizePool Config"}
          icon={FaPen}
          sx={{
            bgcolor: "#eef7eb",
            color: "#54ac3f",
            // marginRight: "10px"
          }}
          onClick={() => {
            // dispatch(
            //   PrizePoolAction.GetPrizePool_Detail(a, () =>
            //     setIsEditModalOpen(true)
            //   )
            // );
            setIsManagerEditModalOpen(true);
          }}
        />
      ),
    },
  ];

  const columnsPool = [
    {
      title: "Pool Size",
      dataIndex: "poolSize",
      key: "poolSize",
      // width: "2%",
    },
    {
      title: "Winning Coins",
      dataIndex: "winningAmount",
      key: "winningAmount",
      // width: "5%",
    },
    {
      title: "Users In Pool",
      dataIndex: "usersInPool",
      key: "usersInPool",
      // width: "5%",
    },
    {
      title: "Action",
      dataIndex: "id",
      key: "id",
      // width: "5%",
      render: (a, b) => (
        <Actions.Button
          title={"View PrizePool Details"}
          icon={FaEye}
          sx={{
            bgcolor: "#d9dcea",
          }}
          onClick={() => { history.push(`/prizepool/${a}`) }}
        />
      ),
    },
  ];

  const columnsWinners = [
    {
      title: "",
      dataIndex: "imageThumbUrl",
      key: "imageThumbUrl",
      width: "1%",
      render: (i, record) => <Avatar src={record?.user?.imageThumbUrl} />,
    },
    {
      title: "User Name",
      dataIndex: "fullName",
      key: "fullName",
      render: (i, record) => `${record?.user?.fullName}`,
    },
    {
      title: "Email",
      dataIndex: "email",
      key: "email",
      render: (i, record) => `${record?.user?.email}`,
    },
    {
      title: "Winning Coins",
      dataIndex: "winningAmount",
      key: "winningAmount",
      render: (_, record) => `${record?.luckydrawPool?.winningAmount}`,
    },
    // {
    //   title: "Status",
    //   dataIndex: "status",
    //   key: "status",
    //   render: (e) => (
    //     <div>
    //       {e == 1 ? (
    //         <p className="tblActive">Paid</p>
    //       ) : (
    //         <p className="tblIn-Active">Unpaid</p>
    //       )}
    //     </div>
    //   ),

    //   // width: "5%",
    // },
    // {
    //   title: "Action",
    //   dataIndex: "status",
    //   key: "status",
    //   render: (isactive, user) => {

    //     return (
    //       <div
    //         onClick={(e) => {
    //           e.preventDefault();
    //           e.stopPropagation();
    //         }}
    //       >
    //         {
    //           <div>
    //             <Switch
    //               checked={isactive == 1 ? false : true}
    //               onChange={(e) => {
    //                 dispatch(
    //                   PrizePoolAction.UpdateLuckydrawWinners(user?.id, () => {
    //                     const getUsersByPage = {
    //                       limit: 10,
    //                       offSet: (currentPage - 1) * 10,
    //                     };
    //                     dispatch(PrizePoolAction.GetLuckydrawWinners(getUsersByPage));
    //                   })
    //                 );
    //                 // setSearch("");
    //               }}
    //             />
    //           </div>
    //         }
    //       </div>
    //     );
    //   },
    // },
  ];

  // function callback(key) {
  //     setTabName(key);
  //     // setSearch("");
  //     // const objTabNameFilter = {
  //     //   limit: 10,
  //     //   offSet: 0,
  //     //   status: key,
  //     //   gameId,
  //     // };
  //     // dispatch(WinnersAction.GetWinners(objTabNameFilter));
  //   }

  return (
    <>
      <Layout.DashboardHeader
        columnSpacing={5}
        customizeStyle={{
          display: "flex",
          padding: 25,
          backgroundColor: "#fffcfc",
          marginLeft: 2,
        }}
      >
        <Header headings={headerProps} />

        <Tabs
          className="winnersTabs"
          defaultActiveKey="done"
          onChange={setTabName}
        >
          <TabPane tab="Games Pool Management" key="done">
            <div className="tbl_game">
              <Table
                dataSource={(data?.games || []).filter(g => g?.name?.toLowerCase() !== 'hangman')}
                columns={columns}
                pagination={false}
              />
            </div>
          </TabPane>

          <TabPane tab="Raffle Drawer Pool Management" key="manager">
            <div className="tbl_game">
              <Table
                dataSource={[data?.luckydraw?.data]}
                columns={columnsManager}
                pagination={false}
              />
            </div>
          </TabPane>

          <TabPane tab="Raffle Drawer Pool List" key="list">
            <div className="tbl_game">
              <Table
                dataSource={data?.pools?.rows}
                columns={columnsPool}
                pagination={false}
              />
              <div style={{ width: "100%", marginTop: "3rem", marginBottom: "3rem" }}>
              <Pagination
                responsive="true"
                showLessItems="true"
                defaultCurrent={1}
                current={currentPage}
                total={winnerCount ? winnerCount : 0}
                onChange={(p) => {
                  handle_pool(p);
                }}
              />
              </div>
            </div>
          </TabPane>

          <TabPane tab="Raffle Drawer Pool Winner" key="winner">
            <div className="tbl_game">
              <Table
                dataSource={data?.winners?.winners}
                columns={columnsWinners}
                pagination={false}
              />
              <div style={{ width: "100%", marginTop: "3rem", marginBottom: "3rem" }}>
              <Pagination
                responsive="true"
                showLessItems="true"
                defaultCurrent={1}
                current={currentPage}
                total={winnerCount ? winnerCount : 0}
                onChange={(p) => {
                  handle_payDone(p);
                }}
              />
              </div>
            </div>
          </TabPane>
        </Tabs>
      </Layout.DashboardHeader>

      {/* View Modal  */}

      <Dialog
        open={isModalOpen && !data.loader}
        onClose={handleCancel}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        sx={{
          ".MuiPaper-root": {
            borderRadius: "10px",
            width: "min(100%, 500px)",
            margin: "1rem",
            py: 1,
          },
        }}
      >
        <DialogTitle id="alert-dialog-title">
          <Stack alignItems="center" spacing={2}>
            <Avatar
              shape="square"
              size={50}
              alt={data?.gameDetail?.name}
              sx={{ width: 100, height: 100 }}
              src={data?.gameDetail?.imageThumbUrl}
            />
            <Typography
              sx={{
                fontSize: "16px",
                fontWeight: "bold",
              }}
            >
              {data?.gameDetail?.name || "Game Name"}
            </Typography>
          </Stack>
        </DialogTitle>
        <DialogContent>
          <Stack spacing={4} py={2}>
            <Stack spacing={1.5} sx={{ width: "100%" }}>
              <Row justify="space-around">
                <Col span={12}>
                  <Typography
                    style={{
                      color: "#435179",
                      fontWeight: 600,
                      fontSize: "16px",
                      flex: 1,
                    }}
                  >
                    Free Games Played:
                  </Typography>
                </Col>
                <Col span={12}>
                  <Typography
                    style={{
                      color: "#000",
                      fontWeight: 600,
                      fontSize: "16px",
                      alignContent: "end",
                      justifyContent: "end",
                      alignItems: "end",
                    }}
                  >
                    {data?.gameDetail?.freeGamesPlayed || 0}
                  </Typography>
                </Col>
              </Row>
              <Divider />
              <Row justify="space-around">
                <Col span={12}>
                  <Typography
                    style={{
                      color: "#435179",
                      fontWeight: 600,
                      fontSize: "16px",
                      flex: 1,
                    }}
                  >
                    Required Users:
                  </Typography>
                </Col>
                <Col span={12}>
                  <Typography
                    style={{
                      color: "#000",
                      fontWeight: 600,
                      fontSize: "16px",
                      alignContent: "end",
                      justifyContent: "end",
                      alignItems: "end",
                    }}
                  >
                    {data?.gameDetail?.requiredUsers || "N/A"}
                  </Typography>
                </Col>
              </Row>
              <Divider />
              <Row justify="space-around">
                <Col span={12}>
                  <Typography
                    style={{
                      color: "#435179",
                      fontWeight: 600,
                      fontSize: "16px",
                      flex: 1,
                    }}
                  >
                    Users in Current Pool:
                  </Typography>
                </Col>
                <Col span={12}>
                  <Typography
                    style={{
                      color: "#000",
                      fontWeight: 600,
                      fontSize: "16px",
                      alignContent: "end",
                      justifyContent: "end",
                      alignItems: "end",
                    }}
                  >
                    {data?.gameDetail?.usersInCurrentPool || 0}
                  </Typography>
                </Col>
              </Row>
              <Divider />
              <Row justify="space-around">
                <Col span={12}>
                  <Typography
                    style={{
                      color: "#435179",
                      fontWeight: 600,
                      fontSize: "16px",
                      flex: 1,
                    }}
                  >
                    Total Coins Required:
                  </Typography>
                </Col>
                <Col span={12}>
                  <Typography
                    style={{
                      color: "#000",
                      fontWeight: 600,
                      fontSize: "16px",
                      alignContent: "end",
                      justifyContent: "end",
                      alignItems: "end",
                    }}
                  >
                    {data?.gameDetail?.totalCoinsRequired}
                  </Typography>
                </Col>
              </Row>
            </Stack>
          </Stack>
        </DialogContent>
        <DialogActions
          component={Stack}
          direction="row"
          width="100%"
          sx={{
            justifyContent: "center",
            pb: 2,
            gap: {
              sm: 1.25,
              xs: 1,
            },
          }}
        >
          <CustomButton
            sx={{
              flex: 1,
              maxWidth: "150px",
            }}
            onClick={() => setIsModalOpen(false)}
          >
            Done
          </CustomButton>
        </DialogActions>
      </Dialog>

      {/* Update Modal */}

      <Dialog
        open={isEditModalOpen}
        onClose={handleCancel}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        sx={{
          ".MuiPaper-root": {
            borderRadius: "10px",
            width: "min(100%, 500px)",
            margin: "1rem",
            py: 2,
          },
        }}
      >
        <DialogTitle id="alert-dialog-title">
          <Stack alignItems="center" spacing={2}>
            <Avatar
              shape="square"
              size={100}
              alt={data?.gameDetail?.name}
              sx={{ width: 100, height: 100 }}
              src={data?.gameDetail?.imageThumbUrl}
            />
            <Typography sx={{ fontSize: "16px", fontWeight: "bold" }}>
              {data?.gameDetail?.name || "Game Name"}
            </Typography>
          </Stack>
        </DialogTitle>
        <DialogContent>
          <Stack spacing={3} py={1}>
            <Stack spacing={1} sx={{ width: "100%" }}>
              <Row justify="space-around">
                <Col span={24}>
                  <Typography
                    style={{
                      color: "#435179",
                      fontWeight: 600,
                      fontSize: "16px",
                      flex: 1,
                    }}
                  >
                    New Prizepool Amount:
                  </Typography>
                </Col>
                <Col span={24} style={{ justifyContent: "center" }}>
                  <Input
                    disabled
                    prefix={"£"}
                    value={requiredUsers}
                    defaultValue={data?.gameDetail?.requiredUsers}
                    style={{
                      width: "100%",
                      backgroundColor: "#f5f5f5",
                      border: "none",
                      padding: "10px 28px",
                      fontSize: "16px",
                    }}
                  />
                </Col>
              </Row>
              <Divider />
              <Row justify="space-around">
                <Col span={24}>
                  <Typography
                    style={{
                      color: "#435179",
                      fontWeight: 600,
                      fontSize: "16px",
                      flex: 1,
                    }}
                  >
                    Minimum Users required:
                  </Typography>
                </Col>
                <Col span={24} style={{ justifyContent: "center" }}>
                  <Input
                    type="number"
                    defaultValue={data?.gameDetail?.requiredUsers}
                    style={{
                      width: "100%",
                      backgroundColor: "#f5f5f5",
                      border: "none",
                      padding: "10px 28px",
                      fontSize: "16px",
                    }}
                    onChange={(e) => setRequiredUsers(e.target.value)}
                  />
                </Col>
              </Row>
              <Divider />
              <Row justify="space-around">
                <Col span={24}>
                  <Typography
                    style={{
                      color: "#435179",
                      fontWeight: 600,
                      fontSize: "16px",
                      flex: 1,
                    }}
                  >
                    Minimum Coins required:
                  </Typography>
                </Col>
                <Col span={24} style={{ justifyContent: "center" }}>
                  <Input
                    disabled
                    value={
                      requiredUsers
                        ? requiredUsers * 10
                        : data?.gameDetail?.totalCoinsRequired
                    }
                    defaultValue={
                      requiredUsers
                        ? requiredUsers * 10
                        : data?.gameDetail?.totalCoinsRequired
                    }
                    style={{
                      width: "100%",
                      backgroundColor: "#f5f5f5",
                      border: "none",
                      padding: "10px 28px",
                      fontSize: "16px",
                    }}
                  />
                </Col>
                <Col>
                  <Typography
                    style={{
                      marginTop: "10px",
                      color: "#FF0023",
                      fontWeight: 500,
                      fontSize: "14px",
                      marginRight: "2px",
                      display: "flex",
                      justifyContent: "between",
                      alignItems: "center",
                    }}
                  >
                    <IoIosInformationCircleOutline
                      size={20}
                      style={{
                        marginRight: "5px",
                      }}
                    />
                    Please ensure that the required users are in the multiples
                    of 100
                  </Typography>
                </Col>
              </Row>
            </Stack>
          </Stack>
        </DialogContent>
        <DialogActions
          component={Stack}
          direction="row"
          width="100%"
          sx={{ justifyContent: "center", pb: 2, gap: { sm: 1.25, xs: 1 } }}
        >
          <CustomButton
            variant="primary"
            sx={{ flex: 1, maxWidth: "150px" }}
            onClick={() => UpdatePrizeDetails()}
          >
            Update
          </CustomButton>
          <CustomButton
            variant="contained"
            sx={{
              border: "none",
              borderRadius: "10px",
              flex: 1,
              maxWidth: "150px",
              backgroundColor: "#425078",
              px: 3,
              py: 1.5,
            }}
            onClick={() => setIsEditModalOpen(false)}
          >
            Cancel
          </CustomButton>
        </DialogActions>
      </Dialog>

      {/* Update Modal Manager*/}

      <Dialog
        open={isManagerEditModalOpen}
        onClose={handleCancel}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        sx={{
          ".MuiPaper-root": {
            borderRadius: "10px",
            width: "min(100%, 500px)",
            margin: "1rem",
            py: 2,
          },
        }}
      >
        <DialogContent>
          <Stack spacing={3} py={1}>
            <Stack spacing={1} sx={{ width: "100%" }}>
              <Row justify="space-around">
                <Col span={24}>
                  <Typography
                    style={{
                      color: "#435179",
                      fontWeight: 600,
                      fontSize: "16px",
                      flex: 1,
                    }}
                  >
                    Required Users:
                  </Typography>
                </Col>
                <Col span={24} style={{ justifyContent: "center" }}>
                  <Input
                    type="number"
                    value={requiredUsersPool}
                    // defaultValue={data?.luckydraw?.data?.requiredUsers}
                    style={{
                      width: "100%",
                      backgroundColor: "#f5f5f5",
                      border: "none",
                      padding: "10px 28px",
                      fontSize: "16px",
                    }}
                    onChange={(e) => setRequiredUsersPool(e.target.value)}
                  />
                </Col>
              </Row>
              <Divider />
              <Row justify="space-around">
                <Col span={24}>
                  <Typography
                    style={{
                      color: "#435179",
                      fontWeight: 600,
                      fontSize: "16px",
                      flex: 1,
                    }}
                  >
                    Winning Coins:
                  </Typography>
                </Col>
                <Col span={24} style={{ justifyContent: "center" }}>
                  <Input
                    type="number"
                    value={winningAmount}
                    style={{
                      width: "100%",
                      backgroundColor: "#f5f5f5",
                      border: "none",
                      padding: "10px 28px",
                      fontSize: "16px",
                    }}
                    onChange={(e) => setWinningAmount(e.target.value)}
                  />
                </Col>
              </Row>
              <Divider />
              <Row justify="space-around">
                <Col span={24}>
                  <Typography
                    style={{
                      color: "#435179",
                      fontWeight: 600,
                      fontSize: "16px",
                      flex: 1,
                    }}
                  >
                    Total Users:
                  </Typography>
                </Col>
                <Col span={24} style={{ justifyContent: "center" }}>
                  <Input
                    disabled
                    value={data?.luckydraw?.data?.usersInCurrentPool}
                    style={{
                      width: "100%",
                      backgroundColor: "#f5f5f5",
                      border: "none",
                      padding: "10px 28px",
                      fontSize: "16px",
                    }}
                  />
                </Col>
              </Row>
            </Stack>
          </Stack>
        </DialogContent>
        <DialogActions
          component={Stack}
          direction="row"
          width="100%"
          sx={{ justifyContent: "center", pb: 2, gap: { sm: 1.25, xs: 1 } }}
        >
          <CustomButton
            variant="primary"
            sx={{ flex: 1, maxWidth: "150px" }}
            onClick={() => UpdateManagerPoolDetails()}
          >
            Update
          </CustomButton>
          <CustomButton
            variant="contained"
            sx={{
              border: "none",
              borderRadius: "10px",
              flex: 1,
              maxWidth: "150px",
              backgroundColor: "#425078",
              px: 3,
              py: 1.5,
            }}
            onClick={() => setIsManagerEditModalOpen(false)}
          >
            Cancel
          </CustomButton>
        </DialogActions>
      </Dialog>

    </>
  );
};
export default PrizePool;
